
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import NoticeAndDocList from './noticeAndDoc.vue';
import Course from './../onlineClass/course.vue';

@Component({
  components: { NoticeAndDocList, Course }
})
export default class Home extends Vue {
  searchValue: string = '';
  searchKey: string = '';
  activeName: string = 'All';
  pageIndex: number = 1;
  pageSize: number = 10;
  docProduct: string  = '全部';
  docProductId: string  = '';
  productVersion: string  = '';
  docProductOptions: Array<{[key: string]: any}> = [{ID: '', Title: '全部'}]; // 文档产品列表
  productVersionOptions: Array<{[key: string]: any}> = []; // 文档产品版本号列表
  firstVideo: {[key: string]: any} = {};

  @Getter globalSearchObj: {[key: string]: any};
  @Getter globalSearchList: {[key: string]: any};
  @Getter category: {[key: string]: any};
  @Getter doccatalog: {[key: string]: any};
  @Getter courseCategory: {[key: string]: any};

  @Action getGlobalSearch: (params: object) => void;
  @Action getGlobalSearchNotice: (params: object) => void;
  @Action getGlobalSearchDoc: (params: object) => void;
  @Action getGlobalSearchClass: (params: object) => void;
  @Action getCategory: (params: object) => void;
  @Action getDoccatalog: (params: object) => void;
  @Action getCourseCategory: (params: object) => void;

  @Watch('globalSearchObj', {deep: true})
  handleChangeSearchKey(val: any, oldVal: any) {
    this.searchValue = val.searchKey;
    this.onSearch();
  }

  onSearch() {
    this.searchKey = this.searchValue;
    if (this.activeName !== 'Courses') {
      this.pageIndex = 1;
      this.requestData();
    } else {
      this.$refs.search && (this.$refs.search as HTMLFormElement).handleSearch();
    }
  }

  get params() {
    return {
      keyword: this.searchKey,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };
  }

  mounted() {
    const { tabname, searchkey } = this.$route.query;
    this.activeName = tabname === '文档' ? 'Documents' : this.activeName;
    this.searchValue = tabname === '文档' && searchkey ? searchkey : (this.globalSearchObj as any).searchKey;
    this.searchKey = this.searchValue;
    this.requestData();
    this.requestSelectOptions();
  }

  unique4(arr: any) {
    const newArr = [];
    for (let i = 0; i < arr.length; i++) {
      if (newArr.indexOf(arr[i]) === -1) {
          newArr.push(arr[i]);
      }
    }

    return newArr;
  }

  replaceWord(key: any, val: any) {
    const htmlStr = '<em>' + key + '</em>';
    const reg =  new RegExp('(' + key + ')', 'gi');

    return val && val.replace(reg, htmlStr);
  }

  highlightKeyword(title: string) {
    const newSearchKey = this.searchKey;
    const engStrReg = /[a-zA-Z]+/gi;
    const zhStrReg = /[\u4e00-\u9fa5]/g;
    const numberStrReg = /[0-9]/g;
    let englishArr = newSearchKey.match(engStrReg) || [];
    englishArr = this.unique4(englishArr);
    let znArr = newSearchKey.match(zhStrReg) || [];
    znArr = this.unique4(znArr);
    let numberArr = newSearchKey.match(numberStrReg) || [];
    numberArr = this.unique4(numberArr);
    let newTitle = title;

    englishArr.forEach((item: any) => {
      newTitle = this.replaceWord(item, newTitle);
    });

    numberArr.forEach((item: any) => {
      newTitle = this.replaceWord(item, newTitle);
    });

    znArr.forEach((item: any) => {
      // 关键字作为正则
      newTitle = this.replaceWord(item, newTitle);
    });

    return newTitle;
  }

  moreVideo() {
    this.$router.push({
      path: '/course',
      query: { coursekey: this.searchKey }
    });
  }

  handleSizeChange(pageSize: number) {
    this.pageIndex = 1;
    this.pageSize = pageSize;
    this.requestData();
  }

  handleCurrentChange(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.requestData();
  }

  changeProduct(value: string) {
    this.docProduct = value;
    const filterItem = this.docProductOptions.filter((item: any) => item.Title === value);
    this.docProductId = filterItem.length && filterItem[0].ID || '';
    if (this.docProductId) {
      this.requestDocDataByVersion().then(() => {
        this.pageIndex = 1;
        this.requestData();
      });
    } else {
      this.productVersion = '';
      this.productVersionOptions = [];
      this.requestData();
    }
  }

  changeVersion(value: any) {
    this.docProductOptions = value;
    this.getGlobalSearchDoc({
      ...this.params,
      product: this.docProduct,
      version: this.productVersion
    });
  }

  requestDocDataByVersion() {
    return (this.getDoccatalog({
      nodeId: this.docProductId
    }) as any).then(() => {
      const { infos: theInfos } = (this.doccatalog as any) || { infos: [] };
      this.productVersion = theInfos && theInfos[0] && theInfos[0].label || '';
      this.productVersionOptions = theInfos && theInfos.length && theInfos.map((item: any) => ({
        label: item && item.label,
        value: item && item.label
      })) || [];
    });
  }

  requestSelectOptions() {
    (this.getCategory({
      groupName: 'DocumentCenter'
    }) as any).then(() => {
      const { infos } = this.category;
      const { children } =  Array.isArray(infos) && (infos[0] as any) || {children: []};
      // this.docProduct = children && children[0].Title || '';
      // this.docProductId = children && children[0].ID || '';
      this.docProductOptions = [{ID: '', Title: '全部'}, ...children] || [{ID: '', Title: '全部'}];
      if (this.docProductId) this.requestDocDataByVersion();
    });
  }

  requestData() {
    if (this.activeName === 'All') {
      this.getGlobalSearch({
        ...this.params
      });
      // (this.getCourseCategory({
      //   courseName: this.searchKey || '%',
      //   typeId: '',
      //   page: 1
      // }) as any).then(() => {
      //   const { data } = this.courseCategory.result || { data: []};
      //   this.firstVideo = data && data.length && data[0] || {};
      // });
    } else if (this.activeName === 'Documents') {
      this.getGlobalSearchDoc({
        ...this.params,
        product: this.docProduct === '全部' ? '' : this.docProduct,
        version: this.productVersion
      });
    } else if (this.activeName === 'News') {
      this.getGlobalSearchNotice({
        ...this.params
      });
    }
  }

  handleTabClick(tab: any) {
    this.pageIndex = 1;
    this.activeName = tab.name;
    this.requestData();
  }
}
